import { render, staticRenderFns } from "./SpinnerWheel.vue?vue&type=template&id=2a3e24a5&scoped=true&"
import script from "./SpinnerWheel.vue?vue&type=script&lang=js&"
export * from "./SpinnerWheel.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerWheel.vue?vue&type=style&index=0&id=2a3e24a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3e24a5",
  null
  
)

export default component.exports